var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 409.605,
    height: 307.201,
    viewBox: "0 0 409.605 307.201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-off",
    transform: "translate(0 -51.202)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2853",
    "data-name": "Group 2853"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2852",
    "data-name": "Group 2852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9397",
    "data-name": "Path 9397",
    d: "M358.4,75.338,334.269,51.2,295.987,89.49A208.074,208.074,0,0,0,204.8,68.268c-87.567,0-163.835,55-204.8,136.535,20.137,40.084,48.886,73.585,83.236,97.449L51.205,334.267,75.341,358.4l38.216-38.216,44.252-44.237h-.015ZM119.47,204.8A85.328,85.328,0,0,1,204.8,119.468a84.456,84.456,0,0,1,46.935,14.269l-24.986,24.98a50.908,50.908,0,0,0-68.034,68.034l-24.98,24.986A84.565,84.565,0,0,1,119.47,204.8Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2855",
    "data-name": "Group 2855"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2854",
    "data-name": "Group 2854"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9398",
    "data-name": "Path 9398",
    d: "M353.121,128.888l-64.164,64.164a85.844,85.844,0,0,1,1.183,11.75,85.328,85.328,0,0,1-85.335,85.335,85.356,85.356,0,0,1-11.75-1.183L148.6,333.421a206.393,206.393,0,0,0,56.2,7.921c87.567,0,163.835-54.984,204.8-136.535A268.134,268.134,0,0,0,353.121,128.888Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.d93bab063b53e0191caa04623f1daba7.svg";
export { ForwardRef as ReactComponent };